import { includes } from 'lodash';

import { SCOPES } from 'constants/roles';
import { checkScopesPermition } from 'utils/check-permissions';

export const showInstancePurchaseOption = (scopes, instanceRestrictions, subscriptionExpiry, expireStatus = ['on_trial', 'in_grace', 'no_subscription']) => {
  const haveRestriction = includes(expireStatus, instanceRestrictions);

  return checkScopesPermition(scopes, SCOPES.INSTANCE_OWNER) && (haveRestriction || subscriptionExpiry);
};



// WEBPACK FOOTER //
// ./src/utils/check-purchase.js